export default __webpack_public_path__ + "static/media/icon-MOBILE.c7741546.svg";